import './polyfill';

import * as Sentry from '@sentry/browser';
import React from 'react';
import { createRoot } from 'react-dom/client';
import 'react-phone-input-2/lib/bootstrap.css';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { PopperContent } from 'reactstrap';
import { APIClient } from './APIClient';
import { ConCatApp } from './ConCatApp';
import { init } from './components/json-form/JSONForm';
import { store } from './services';
import { TranslationProvider } from './translations';
import { APIClient as BaseClient } from './utils/APIClient';
import { captureError } from './utils/errorHandling';

import './styles/index.scss';

// patch default popper offset
PopperContent.defaultProps.offset = [0, 5];

(Error as ErrorConstructor & { stackTraceLimit: number }).stackTraceLimit = 25;

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [Sentry.extraErrorDataIntegration()],
  });
}

const httpBase = new BaseClient();
window.api = new APIClient(new BaseClient());

init(httpBase, captureError);

createRoot(document.getElementById('app')!).render(
  <Provider store={store}>
    <TranslationProvider>
      <BrowserRouter>
        <ConCatApp />
      </BrowserRouter>
      <ToastContainer autoClose={7000} draggable newestOnTop pauseOnFocusLoss />
    </TranslationProvider>
  </Provider>,
);

declare global {
  let api: APIClient;
  interface Window {
    api: APIClient;
    reactHistory: (path: string) => void;
  }
  const VERSION: string;
  const SENTRY_DSN: string;
}
